export const baseUrl = 'https://derwent-central-api.azure-api.net/app';
export const GOOGLE_API_KEY = 'AIzaSyAx4yByCiA5JA30W4LdRFJd7eP4vGGdlfo';
export const azureProfileFunKey =
  'KpUHyV2NAwMG/xpUvVgaZwlgUjZdyalmGd8C0qcVdnigbcgyJ5VUlA==';
